export default __webpack_public_path__ + "static/media/lira.89fdad7f.svg";